import { render, staticRenderFns } from "./KbQuestion.vue?vue&type=template&id=81c3c980&scoped=true&"
import script from "./KbQuestion.vue?vue&type=script&lang=js&"
export * from "./KbQuestion.vue?vue&type=script&lang=js&"
import style0 from "./KbQuestion.vue?vue&type=style&index=0&id=81c3c980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c3c980",
  null
  
)

export default component.exports